import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Spinner,
  Row,
  Col,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import { RestroUsers } from "../../../../services/DatabaseService/RestroUsers";

// BreadCrumb Component
const BreadCrumb = ({ title, pageTitle, breadcrumbItems }) => {
  return (
    <div className="mb-4">
      
      <Row className="align-items-center">
        <Col>
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h4 className="mb-0">{title}</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">{pageTitle}</li>
                <li className="breadcrumb-item active">{title}</li>
              </ol>
            </div>
          </div>
        </Col>
      </Row>
      {breadcrumbItems && breadcrumbItems.length > 0 && (
        <div className="mt-2">
          {breadcrumbItems.map((item, index) => (
            <a key={index} href={item.link} className="btn btn-link">
              {item.title}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

const RestroDetailPage = () => {
  const { apiKey } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDatabyApiKey = async (apiKey) => {
    try {
      const response = await RestroUsers.getByApiKey(apiKey);
      setData(response); 
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (apiKey) fetchDatabyApiKey(apiKey);
  }, [apiKey]);


console.log(data)

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <Spinner color="primary" />
      </div>
    );
  }

  if (!data) {
    return (
      <div className="text-center text-danger mt-4">
        Failed to load database details
      </div>
    );
  }

  const breadcrumbItems = [
    { title: "Back To List", link: "/database-management" },
  ];

  const toggle = (id) => {
    setOpen(open === id ? "" : id);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          pageTitle="Database"
          title="Database Detail"
          breadcrumbItems={breadcrumbItems}
        />
      </div>
      <Row>
        {/* Database Info */}
        <Col md={4}>
          <Card className="mb-4 shadow-sm">
            <CardBody>
              <h3 className="h4 mb-3">{data.tenantName}</h3>
              <p className="text-muted">
                <strong>Description:</strong>{" "}
                {data.country || "No description available"}
              </p>
            </CardBody>
          </Card>
        </Col>

        {/* Tables Accordion */}
        <Col md={8}>
          <Card className="shadow-sm">
            <CardHeader className="border-0">
              <h5 className="mb-0">Detail:</h5>
            </CardHeader>
            <CardBody>
              <p>TenantCode: {data.tenantCode} </p>
              <p>Address: {data.address} </p>
              <p>Phone Number: {data.phone} </p>
              <p>Api Key: {data.apiKey} </p>
              <p>Registered Date: {data.regsiteredDate}</p>
              <p>Valid Till: {data.validTill}</p>
              <p>amcStartDate: {data.amcStartDate}</p>
              <p>amcEndDate: {data.amcEndDate}</p>
              <p>isDemoVersion: {data.isDemoVersion? "true":"false"}</p>
              <p>isCloudVersion: {data.isCloudVersion? "true":"false"}</p>
               <p>panVatNumber: {data.panVatNumber}</p>
               <p>isIRDVeriied: {data.isIRDVeriied? "true":"false"}</p>
               <p>cbmsUsername: {data.cbmsUsername}</p>
               <p>isAbbreviated: {data.isAbbreviated? "true":"false"}</p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default RestroDetailPage;